// this file handles the carousels found around the web page.

import Flickity from 'flickity'
// import 'flickity/dist/flickity.min.css'
import 'flickity-imagesloaded'

export function setupCarousels () {
  const carousels = document.querySelectorAll('.carousel')

  for (const carousel of carousels) {
    setupCarousel(carousel)
  }
}

function setupCarousel (element) {
  const options = {
    cellAlign: 'center',
    imagesLoaded: true,
    contain: true,
    autoPlay: 5000,
    wrapAround: true,
    prevNextButtons: true,
    adaptiveHeight: true,
    pageDots: false
  }

  const instance = new Flickity(element, options)

  console.log({ instance })
}
